import { matchPath } from 'react-router-dom';
import { path, createCachedSelector, prop, stringComposeKeySelectors } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { locationSelector } from './location.selector';

export const isMatchedPathnameSelector = createCachedSelector(
  [
    path(locationSelector).pathname(),
    prop<{ pattern: string }>().pattern(),
    prop<{ isExact?: boolean }>().isExact(),
  ],
  (pathname, pattern, isExact) => {
    return Boolean(matchPath({ path: pattern, end: Boolean(isExact) }, pathname));
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: stringComposeKeySelectors(
    prop<{ pattern: string }>().pattern(),
    prop<{ isExact?: boolean }>().isExact(),
  ),
});
